import type { SceneComponent } from './scenes/types.js';
import { wheelDescriptor } from './descriptors/wheel.js';
import { scratchDescriptor } from './descriptors/scratch.js';
import { cardsDescriptor } from './descriptors/cards.js';
import { plinkoDescriptor } from './descriptors/plinko.js';
import { diceDescriptor } from './descriptors/dice.js';
import { kenoDescriptor } from './descriptors/keno.js';
import { minesDescriptor } from './descriptors/mines.js';

export interface GameDescriptor {
  /** Equals the backend gameCode (also the route :code and the gameType for these three). */
  code: string;
  scene: SceneComponent;
  supportsAuto: boolean;
  /** Round protocol; default 'single-shot'. Mines (Plan B) is 'stateful'. */
  protocol?: 'single-shot' | 'stateful';
  /** Has a pre-bet selection surface (dice, keno). */
  selectable?: boolean;
}

const REGISTRY: Record<string, GameDescriptor> = {
  wheel: wheelDescriptor,
  scratch: scratchDescriptor,
  cards: cardsDescriptor,
  plinko: plinkoDescriptor,
  dice: diceDescriptor,
  keno: kenoDescriptor,
  mines: minesDescriptor,
};

export function getDescriptor(code: string): GameDescriptor | null {
  return REGISTRY[code] ?? null;
}
